<script setup lang="ts">
    /**
     * Content som ska renderas i footern i ReceptforskrivningMallForm.vue
     */

    import KButton from "@/components/Button.vue";
    import TabFooter from "@/tabs/TabFooter.vue";
    import { Portal } from "portal-vue";

    defineProps<{
        /**
         * Används för att få formulärkomponenterna att registrera sig med formuläret efter rendering
         * och för att targetta rätt tab med portalen. Behövs för att
         * formulärkomponenterna här renderas utanför KForm. Se ReceptforskrivningForm.vue hur det görs och används.
         * Du behöver troligen inte overrida det som sätts där.
         */
        tabId: number;
        /**
         * Används för att få formulärkomponenterna att registrera sig med formuläret efter rendering. Behövs för att
         * formulärkomponenterna här renderas utanför KForm. Se ReceptforskrivningForm.vue hur det görs och används.
         * Du behöver troligen inte overrida det som sätts där.
         */
        formIdPrefix: string;
        mallId?: string;
    }>();

    const emit = defineEmits<{
        (e: "accept"): void;
        (e: "cancel"): void;
    }>();

    const onAccept = () => {
        emit("accept");
    };

    const onCancel = () => {
        emit("cancel");
    };
</script>

<template>
    <portal :to="`tab-${tabId}`">
        <TabFooter>
            <div class="receptforskrivning-mall-form-portal">
                <div class="form-content">
                    <KGroup
                        name="forhandsvisning"
                        class="span-all free-flow forhandsvisning-group"
                        direction="horizontal"
                    >
                        <div class="section">
                            <KText
                                name="forhandsvisning"
                                label="Förhandsvisning doseringsanvisning"
                                type="textarea"
                                :registerOnMountId="`${formIdPrefix}${tabId}`"
                                readonly
                                disabled
                                class="forhandsvisning"
                            />
                        </div>
                        <KText
                            name="administreringsinstruktion"
                            :registerOnMountId="`${formIdPrefix}${tabId}`"
                            :hidden="true"
                        />
                        <div class="actions">
                            <KButton type="button" size="slim" variant="standard" @click="onAccept">
                                {{ mallId ? "Uppdatera mall" : "Skapa mall" }}
                            </KButton>
                            <KButton type="button" size="small" variant="contour" @click="onCancel">Avbryt</KButton>
                        </div>
                    </KGroup>
                </div>
            </div>
        </TabFooter>
    </portal>
</template>

<style scoped lang="scss">
    @use "@/components/forms/Form/styles/FormContent";
    @import "@/style/form";

    .receptforskrivning-mall-form-portal {
        @include FormContent.content;

        .forhandsvisning-group {
            ::v-deep .group-content {
                align-items: flex-end;

                .section {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    gap: FormContent.$form-column-gap-thin;

                    .apotek {
                        max-width: 30rem;
                    }

                    .forhandsvisning {
                        min-width: FormContent.$k-form-column-width;
                        max-width: 100%;
                        flex-grow: 2;
                    }
                }
                .actions {
                    display: flex;
                    align-items: flex-end;
                    align-self: flex-start;
                    width: fit-content;
                    max-width: 100%;
                    column-gap: calc($form-column-gap / 2);
                    margin-top: auto;
                }
            }
        }
    }
</style>
